<script>
  import { AlertTriangle, LoaderCircle, UserMinus } from 'lucide-svelte';

  export let open = false;
  export let title = '';
  export let description = '';
  export let confirmLabel = 'Xác nhận';
  export let tone = 'danger';
  export let loading = false;
  export let onCancel = () => {};
  export let onConfirm = () => {};

  $: iconClass = tone === 'danger' ? 'bg-red-50 text-red-600' : 'bg-slate-100 text-slate-700';
  $: buttonClass = tone === 'danger'
    ? 'bg-red-600 hover:bg-red-700'
    : 'bg-slate-900 hover:bg-slate-800';
</script>

{#if open}
  <div class="fixed inset-0 z-[70] grid place-items-center bg-slate-950/45 px-4 backdrop-blur-sm">
    <div class="w-full max-w-sm rounded-xl bg-white p-5 shadow-2xl">
      <div class="flex items-start gap-3">
        <div class={`grid h-10 w-10 shrink-0 place-items-center rounded-full ${iconClass}`}>
          {#if tone === 'danger'}
            <AlertTriangle size={18} />
          {:else}
            <UserMinus size={18} />
          {/if}
        </div>
        <div class="min-w-0">
          <h3 class="text-sm font-semibold text-slate-950">{title}</h3>
          <p class="mt-1 text-[13px] leading-5 text-slate-600">{description}</p>
        </div>
      </div>

      <div class="mt-5 flex justify-end gap-2">
        <button
          type="button"
          class="rounded-lg bg-slate-100 px-4 py-2 text-[13px] font-medium text-slate-700 hover:bg-slate-200"
          disabled={loading}
          onclick={onCancel}>
          Hủy
        </button>
        <button
          type="button"
          class={`inline-flex items-center gap-2 rounded-lg px-4 py-2 text-[13px] font-medium text-white disabled:cursor-not-allowed disabled:opacity-60 ${buttonClass}`}
          disabled={loading}
          onclick={onConfirm}>
          {#if loading}
            <LoaderCircle size={14} class="animate-spin" />
          {/if}
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
{/if}
